import server from '@/request';

// 分页获取
export const getBrandLists = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/brand/getByPage', data);
};

// 新增品牌
export const addBrand = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/brand/add', data);
};

// 更新数据
export const updateBrand = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/brand/update', data);
};

// 禁用品牌
export const changeDisableBrandStatus = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/brand/updateEnableFlag', data);
};

// 通过id获取
export const detailBrand = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/brand/detail', data);
};

// 批量删除
export const deleteBrand = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/brand/delByIds', data);
};

// 查询数量
export const getGoodsBrandCount = (data) => {
  return server.post('/xiaozi-saas/wireless/goods/brand/getCount', data);
};
